
function NotFoundPage () {

    return (
        <div className="container-fluid">
            <h1>
                404 Not Found
            </h1>
        </div>
    );
}

export default NotFoundPage;